<template>
  <div>
    <section class="hero is-primary">
      <div class="container">
        <nav
          class="breadcrumb is-small"
          aria-label="breadcrumbs"
        >
          <ul>
            <li>
              <router-link :to="{ name: 'home' }">
                Home
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'playlists' }">
                Playlists
              </router-link>
            </li>
            <li class="is-active">
              <a
                href="#"
                aria-current="page"
              >
                {{ playlistItem.caption || "New" }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <playlist-item-edit />
      </div>
    </section>
    <BaseActionRoundButton
      :icon-class="buttonActionIconClass"
      @click="save()"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PlaylistItemEdit from "../components/PlaylistItemEdit";

export default {
  components: {
    PlaylistItemEdit
  },
  data() {
    return {
      buttonActionIconClass: "fas fa-check"
    };
  },
  computed: {
    ...mapGetters({
      playlistItem: "selectedPlaylistItem"
    })
  },
  created() {
    const playlistId = this.$route.params.playlistId;
    this.fetchPlaylist(playlistId);
    this.fetchPlayListItem({
      playlistId: playlistId,
      itemId: this.$route.params.playlistItemId
    });
  },
  methods: {
    onUpdate(event) {
      this.$store.commit("PLAYLIST_ITEMS_UPDATE_SELECTED", event);
    },
    save() {
      if (
        this.playlistItem &&
        this.playlistItem.template_item &&
        !this.playlistItem.caption
      )
        this.setPlayListItemCaption(this.playlistItem.template_item.caption);
      this.savePlaylistItem().then(() => {
        this.$router.push({
          name: "playlist",
          params: { playlistId: this.$route.params.playlistId },
          query: { edit: "true" }
        });
      });
    },
    ...mapActions([
      "savePlaylistItem",
      "setPlayListItemCaption",
      "fetchPlayListItem",
      "fetchPlaylist",
      "refreshSongs"
    ])
  }
};
</script>

<style lang="scss">
.save {
  @include action-button();
}
</style>



// WEBPACK FOOTER //
// EditPlaylistItem.vue?6d93b95f